import React, { ReactNode, useEffect, useState } from 'react'
import CouponStepper, { CouponStepperDotOption } from '../components/CouponStepper'
import CampaignGoals from '../components/campaignGoals/CampaignGoals';
import BudgetPlanning from '../components/budgetPlanning/BudgetPlanning';
import CouponSummary from '../components/couponSummary/CouponSummary';
import DefineCoupon from '../components/DefineCoupon/DefineCoupon';
import './couponData.css'
import { getAllProducts, updateConfigAndMetaData } from '../services/services';
import { openPopup } from '../../../stateManagement/actions/popupActions';
import { Loader } from '../../../components/loader/Loader';
import { CouponAlertProvider } from '../context/CouponAlert';
import { ThemeProvider, createTheme } from '@mui/material';
import store from '../../../stateManagement/store';
import { MetaData, inPlaygroundMode } from '../utils/utils';
import BannerImageUpload from '../components/CreateBanner/BannerImageUpload';
import OverAndAboveBody from '../components/DefineCoupon/overAndAboveBody/OverAndAboveBody';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

function CouponData() {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const {couponEditType} = store.getState()?.manageCoupons?.data;
  const [dateChanged, setDateChanged] = useState<boolean>(false);
  const [showOverAndAboveBody, setShowOverAndAboveBody] = useState<{ open: boolean, body: Record<string, any> }>({ open: false, body: {} });

  const darkTheme = createTheme({
    palette: {
      mode: localStorage["dark-mode"]=="true" ? 'dark' : 'light',
      primary: {
        main: '#227C9D',
      },
    },
  });
  

  const handleClose = (): void => {
    setAnchorEl(null);
  }

  const handleClick = (event: any):void => {
    setAnchorEl(event.currentTarget);
}

  const handleStepIconClick = (stepNumber: number) => {
    setCurrentStep(stepNumber)
  }

  const incrementCurrentStep = ()=>{
    // setCurrentStep((pre:number)=>{
    //   if(pre === 3){
    //     return pre;
    //   }else{  
    //     return pre+1;
    //   }
    // })
  }

  const updateCurrentStep = (step:number) => {
    setCurrentStep(step);
  }
  const renderCurrentTab = (tab: Number): ReactNode => {
    switch (tab) {
      case MetaData.Coupon_Case_Number["Define Coupons"]:
        return <DefineCoupon setDateChanged={setDateChanged} incrementCurrentStep={incrementCurrentStep} updateCurrentStep={updateCurrentStep}/>;
      case MetaData.Coupon_Case_Number["Campaign Goals"]:
        return <CampaignGoals />;
      case MetaData.Coupon_Case_Number["Budget Planning"]:
        return <BudgetPlanning />;
      case MetaData.Coupon_Case_Number["Create Banner"]:
        return <BannerImageUpload dateChanged={dateChanged} updateCurrentStep={updateCurrentStep} setShowOverAndAboveBody={setShowOverAndAboveBody}/>;
      case MetaData.Coupon_Case_Number["Coupon Summary"]:
        return <CouponSummary />;
      default:
        return <div>Not Found</div>;
    }
  }


  const init = async () => {
    setLoading(true);
    try {
      await updateConfigAndMetaData();
      await getAllProducts();
    } catch (error) {
      console.error(error);
      openPopup("Error", "Error Occured");
    } finally {
      setLoading(false);
    }
  }

  const getSchemePlaygroundOption = () => {
    if((couponEditType === "" || couponEditType === inPlaygroundMode) && MetaData["schemePlayground"] === "true"){
      return <CouponStepperDotOption handleClick={handleClick} handleClose={handleClose} anchorEl={anchorEl}/>
    }
  }

  useEffect(() => {
    init();
  }, [])

  return (
    <CouponAlertProvider>
      <ThemeProvider theme={darkTheme}>
      <div className='coupon-management-wrapper'>
        {
          loading ? <Loader /> :
            <>
            
              <div className='coupon-stepper-container'>
              <FontAwesomeIcon style={{marginLeft:"20px",marginRight:"-50px",color:"rgb(35, 198, 176)",fontSize: "1.5em",width: "1.5em",cursor:"pointer"}} icon={faArrowLeft} onClick={() => {
        window.history.back();
      }} />
                <div className="coupon-stepper-container-inner">
                  <CouponStepper currentStep={currentStep} handleStepIconClick={handleStepIconClick} />
                </div>
                {getSchemePlaygroundOption()}
              </div>
              {showOverAndAboveBody.open ?
          <OverAndAboveBody body={showOverAndAboveBody.body} setShowOverAndAboveBody={setShowOverAndAboveBody} />
          :
              <div className='coupon-management-current-tab-wrapper'>
                {renderCurrentTab(currentStep)}
              </div>
            }
            </>
        }
      </div>
      </ThemeProvider>
    </CouponAlertProvider>
  )
}

export default CouponData